import { Outlet, createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/(app)/pages/$pageId/variants")({
  component: RouteComponent,
  validateSearch: z.object({
    page: z
      .number()
      .int()
      .gt(0)
      .catch(0)
      .transform((v) => (v === 0 ? undefined : v)),
    pageSize: z
      .number()
      .int()
      .gt(0)
      .lte(50)
      .catch(0)
      .transform((v) => (v === 0 ? undefined : v)),
  }),
  loaderDeps: ({ search: { page, pageSize } }) => ({
    page,
    pageSize,
  }),
  loader: async () => {
    return {
      crumb: {
        label: "Variants",
        options: [],
        id: "variants",
      },
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
